var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"linear-progress-bar",style:(_vm.wrapperStyle)},[_c('div',{staticClass:"linear-progress-bar__fill",style:(_vm.fillStyle)}),_vm._v(" "),_vm._t("default",null,{"value":_vm.value})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }